import { Confirm } from "@artists/uikit"
import { Button } from "@mui/material"
import { useCallback } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"

import { format, Root } from "../../../../utils"

interface LastDayWarningProps {
	isOpen: boolean
	votingClosesAt: string
	slug: string
	onClose(): void
}

export const VotingEndedPrompt = ({
	votingClosesAt,
	slug,
	isOpen,
	onClose,
}: LastDayWarningProps) => {
	const { t } = useTranslation("vote")
	const navigate = useNavigate()
	const { title, primaryButton } = t("warnings.votingEnded", {
		returnObjects: true,
	})
	const text = t("warnings.votingEnded.text", {
		date: format(votingClosesAt, "eee, MMM d"),
		time: format(votingClosesAt, "ha z"),
	})

	const onWarningConfirm = useCallback(() => {
		navigate(Root.Challenge.buildPath({ slug }))
	}, [slug, navigate])

	return (
		<Confirm
			open={isOpen}
			onClose={onClose}
			title={title}
			subtitle={text}
			actions={[
				<Button
					color='secondary'
					variant='contained'
					onClick={onWarningConfirm}
					sx={{ textTransform: "none" }}
				>
					{primaryButton}
				</Button>,
			]}
		/>
	)
}
